import { render, staticRenderFns } from "./AccountPasswordForm.vue?vue&type=template&id=2ebfb992&scoped=true&"
import script from "./AccountPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./AccountPasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccountPasswordForm.vue?vue&type=style&index=0&id=2ebfb992&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebfb992",
  null
  
)

export default component.exports